export default "__VITE_ASSET__BTLJS7u0__"